import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { RecurrenceEndEnum, TaskFrequencyPeriod, } from "generated/generated-models";
import { nameof } from "core/util/nameof";
import Datepicker from "app/components/DatePicker";
import Input from "app/components/Input";
import ButtonGroup from "app/components/ButtonGroup";
import { Grid } from "@mui/material";
const setMaxYear = new Date().getFullYear();
const setMaxMonth = new Date().getMonth();
const setMaxDay = new Date().getDate();
const setMaxDate = new Date(setMaxYear + 500, setMaxMonth, setMaxDay);
const TransferUntilInput = ({ values, config }) => {
    const mergedConfig = {
        ...defaultConfig,
        ...config,
    };
    const { minStartingDate, isDirectDebit, clearanceDate } = mergedConfig;
    const showUntilInputBlock = values.frequency !== TaskFrequencyPeriod.Once;
    const numberOfTimesInputEnabled = values.recurrenceEnd === RecurrenceEndEnum.Numberofocurrences;
    const untilDateInputEnabled = values.recurrenceEnd === RecurrenceEndEnum.Bydate;
    if (!showUntilInputBlock) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(Grid, { item: true, xs: 6, children: _jsxs(ButtonGroup, { label: "Until", name: nameof("recurrenceEnd"), children: [_jsx(ButtonGroup.Button, { value: RecurrenceEndEnum.Never, children: "Forever" }), _jsx(ButtonGroup.Button, { value: RecurrenceEndEnum.Bydate, children: "Date" }), _jsx(ButtonGroup.Button, { value: RecurrenceEndEnum.Numberofocurrences, children: "No. of Payments" })] }) }), untilDateInputEnabled && (_jsx(Grid, { item: true, xs: 6, children: _jsx(Datepicker, { name: nameof("endingOn"), label: "End Date", minDate: isDirectDebit ? clearanceDate : minStartingDate, maxDate: setMaxDate }) })), numberOfTimesInputEnabled && (_jsx(Grid, { item: true, xs: 6, children: _jsx(Input, { label: "No. of Payments", name: nameof("numberOfTimesAmount"), type: "wholeNumberPayment" }) }))] }));
};
const defaultConfig = {
    minStartingDate: new Date(),
    minUntilDate: new Date(),
    maxDate: undefined,
    isDirectDebit: false,
    clearanceDate: new Date(),
};
const TransferScheduleInput = ({ values, config }) => {
    const mergedConfig = {
        ...defaultConfig,
        ...config,
    };
    const { minStartingDate, maxDate, isDirectDebit, clearanceDate } = mergedConfig;
    return (_jsxs(_Fragment, { children: [_jsx(Grid, { item: true, xs: 6, children: _jsxs(ButtonGroup, { name: nameof("frequency"), label: "Frequency", children: [_jsx(ButtonGroup.Button, { value: TaskFrequencyPeriod.Once, children: "Once" }), _jsx(ButtonGroup.Button, { value: TaskFrequencyPeriod.Weekly, children: "Weekly" }), _jsx(ButtonGroup.Button, { value: TaskFrequencyPeriod.Fortnightly, children: "Fortnightly" }), _jsx(ButtonGroup.Button, { value: TaskFrequencyPeriod.Monthly, children: "Monthly" })] }) }), _jsx(Grid, { item: true, xs: 6, children: _jsx(Datepicker, { label: "Starting On", name: nameof("startingOn"), minDate: isDirectDebit ? clearanceDate : minStartingDate, maxDate: maxDate }) }), _jsx(TransferUntilInput, { config: mergedConfig, values: values })] }));
};
export default TransferScheduleInput;
